module.exports = __webpack_public_path__ + "static/img/KR.515d556.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/KR.png
// module id = xaZh
// module chunks = 2